import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceforcorporate() {

const cardData = {
keyword: "Best Cab Service for Corporate Employees Pune",
headingDescription: "Citysky Cabs provides organized corporate employee transportation in Pune for IT professionals, office staff, executives, factory employees, and business teams. Services can be planned for daily office pickup and drop, monthly employee transportation, airport transfers, corporate meetings, outstation business travel, and scheduled staff commuting. With flexible cab options and driver-based transportation, companies can arrange practical travel across major business corridors such as Hinjewadi, Kharadi, Magarpatta, Viman Nagar, Baner, Pimpri Chinchwad, Hadapsar, and other important Pune locations.",
topPlaces: [
{
title: "Hinjewadi IT Park",
description: "Hinjewadi IT Park is one of Pune's major technology and employment corridors, with a large number of offices and professionals travelling daily. Corporate employee cabs can support scheduled pickup and drop routes based on employee locations, office timings, and shift requirements."
},
{
title: "Kharadi EON IT Park",
description: "Kharadi EON IT Park is a major corporate destination in eastern Pune with technology companies, business offices, and professional workplaces. Employee transportation can connect staff residences with offices through planned daily routes and convenient pickup schedules."
},
{
title: "Magarpatta City",
description: "Magarpatta City is a prominent integrated business and residential destination with corporate offices and technology companies. Corporate cabs can help employees commute between nearby residential areas and workplaces while also supporting meetings, airport transfers, and business travel."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important travel point for corporate employees, executives, clients, and visiting professionals. Scheduled corporate cabs can provide airport pickup and drop services according to flight timings and business travel requirements."
},
{
title: "Baner",
description: "Baner is a major western Pune business and residential corridor with offices, commercial establishments, and professional activity. Employee cabs can connect staff from Baner and surrounding areas with workplaces across Pune through planned commuting routes."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad is a large industrial, residential, and commercial region with manufacturing units, offices, and a substantial employee population. Corporate transportation can support regular staff commuting, factory shifts, business travel, and office transfers."
},
{
title: "Viman Nagar",
description: "Viman Nagar is a well-connected corporate and commercial locality near Pune Airport with offices, hotels, retail centers, and residential areas. Employee transportation can be arranged for professionals travelling to business locations across Pune."
},
{
title: "Hadapsar",
description: "Hadapsar combines major business, technology, residential, and industrial destinations, making it an important employee transportation corridor. Corporate cabs can support daily office travel, staff pickup and drop, airport transfers, and business journeys."
},
{
title: "Lonavala",
description: "Lonavala is a popular destination for corporate meetings, team outings, company events, and business retreats from Pune. Corporate cabs can provide comfortable group and employee transportation for planned one-way or round-trip journeys."
},
{
title: "Nashik",
description: "Nashik is an important business, industrial, and commercial destination accessible from Pune. Corporate outstation cabs can support employees and business teams travelling for meetings, plant visits, client appointments, training programs, and other professional requirements."
}
],
services: [
{
name: "Corporate Employee Cab Service Pune",
description: "Corporate Employee Cab Service Pune helps companies organize dependable transportation for employees travelling between their residences and workplaces. Routes can be scheduled around office timings, employee locations, shift patterns, and recurring corporate commuting requirements."
},
{
name: "Corporate Employee Taxi Pune",
description: "Corporate Employee Taxi Pune provides practical transportation for office staff, executives, and professional teams. Vehicles can be arranged for daily commuting, business meetings, airport transfers, employee travel, and other company-related transportation needs."
},
{
name: "Employee Transportation Service Pune",
description: "Employee Transportation Service Pune supports businesses that require structured staff mobility across different areas of the city. Pickup points and routes can be planned according to employee residences, workplace locations, office timings, and operational shifts."
},
{
name: "Corporate Cab for Employees Pune",
description: "Corporate Cab for Employees Pune provides scheduled transportation for staff working in IT companies, offices, manufacturing units, and commercial organizations. Companies can arrange suitable vehicles according to passenger numbers, routes, and daily travel schedules."
},
{
name: "Office Employee Cab Pune",
description: "Office Employee Cab Pune is suitable for professionals who need regular transportation between home and workplace. Daily cab routes can be coordinated around reporting times, employee pickup points, office locations, and shift-based schedules."
},
{
name: "Employee Pickup Drop Service Pune",
description: "Employee Pickup Drop Service Pune helps companies manage recurring transportation between employee residences and offices. Pickup and drop schedules can be organized according to staff locations, working hours, designated stops, and route requirements."
},
{
name: "Corporate Cab Booking Pune",
description: "Corporate Cab Booking Pune allows companies to arrange transportation in advance for employees, executives, guests, airport transfers, meetings, and business travel. Booking details can be coordinated according to travel dates, timings, destinations, and vehicle requirements."
},
{
name: "Corporate Cab Rental Pune",
description: "Corporate Cab Rental Pune provides flexible vehicle arrangements for regular employee transportation as well as temporary business requirements. Cabs can be used for office commuting, corporate events, client visits, airport transfers, and scheduled business travel."
},
{
name: "Daily Employee Cab Pune",
description: "Daily Employee Cab Pune provides recurring transportation for employees travelling to and from their workplaces. Daily routes can be planned according to residential pickup points, office timings, employee requirements, and different working shifts."
},
{
name: "Monthly Employee Transportation Pune",
description: "Monthly Employee Transportation Pune is suitable for companies requiring regular staff commuting throughout the month. Transportation plans can cover recurring pickup and drop routes while accommodating office schedules, employee locations, and shift-based travel."
},
{
name: "IT Employee Cab Service Pune",
description: "IT Employee Cab Service Pune supports professionals working in major technology corridors such as Hinjewadi, Kharadi, Magarpatta, Viman Nagar, and other business areas. Routes can be planned around office shifts, employee residences, and company transportation requirements."
},
{
name: "Corporate Office Cab Pune",
description: "Corporate Office Cab Pune provides transportation for employees and business professionals travelling to corporate workplaces. Services can cover daily commuting, office transfers, meetings, airport journeys, and scheduled transportation for visiting employees or teams."
},
{
name: "Company Employee Transport Pune",
description: "Company Employee Transport Pune helps organizations coordinate employee mobility across different residential and business areas. Routes can be arranged for regular office commuting, factory shifts, employee meetings, and other work-related transportation needs."
},
{
name: "Corporate Airport Cab Pune",
description: "Corporate Airport Cab Pune provides scheduled transportation between business locations and Pune International Airport. Employees, executives, clients, and visiting professionals can use airport transfers planned around flight timings and corporate travel schedules."
},
{
name: "Corporate Outstation Cab Pune",
description: "Corporate Outstation Cab Pune supports employees and business teams travelling outside the city for meetings, client visits, training programs, inspections, conferences, and company assignments. One-way and round-trip travel can be arranged according to the itinerary."
},
{
name: "AC Corporate Employee Cab Pune",
description: "AC Corporate Employee Cab Pune provides air-conditioned transportation for comfortable employee commuting and business travel. These cabs can be arranged for daily office routes, airport transfers, meetings, corporate events, and longer professional journeys."
},
{
name: "Affordable Employee Cab Service Pune",
description: "Affordable Employee Cab Service Pune helps businesses organize recurring employee transportation while considering route requirements and travel frequency. Suitable cab arrangements can be planned for office commuting, staff pickup and drop, airport travel, and business journeys."
},
{
name: "Corporate Cab with Driver Pune",
description: "Corporate Cab with Driver Pune provides convenient driver-based transportation for employees, executives, clients, and business teams. It can be used for office commuting, meetings, airport transfers, corporate events, and local or outstation business travel."
},
{
name: "Employee Cab Service Near Me Pune",
description: "Employee Cab Service Near Me Pune is suitable for companies and professionals looking for convenient staff transportation around their workplace or residential area. Services can be planned for regular commuting, pickup and drop, airport transfers, and business travel."
},
{
name: "Staff Transportation Service Pune",
description: "Staff Transportation Service Pune provides organized commuting solutions for office employees, corporate teams, and industrial staff. Pickup locations, routes, vehicle capacity, and schedules can be coordinated according to the company's workforce and operational requirements."
},
{
name: "Corporate Taxi for Employees Pune",
description: "Corporate Taxi for Employees Pune supports scheduled staff transportation for businesses across Pune. Taxis can be arranged for regular office commuting, shift travel, business meetings, airport transfers, and other employee-related transportation requirements."
},
{
name: "Employee Office Pickup Drop Pune",
description: "Employee Office Pickup Drop Pune provides recurring transportation between employee residences and office locations. Companies can organize pickup and drop schedules based on staff locations, office timings, shift patterns, and preferred transportation routes."
},
{
name: "Corporate Travel Cab Pune",
description: "Corporate Travel Cab Pune is suitable for employees, executives, clients, and business teams travelling for meetings, conferences, inspections, training, and corporate events. Cabs can support both local professional travel and longer intercity journeys."
},
{
name: "Private Employee Transportation Pune",
description: "Private Employee Transportation Pune provides dedicated cab arrangements for employees and professional teams who require direct transportation. Services can be organized for office commuting, airport travel, meetings, events, and other scheduled company journeys."
},
{
name: "Corporate Car Rental for Employees Pune",
description: "Corporate Car Rental for Employees Pune provides flexible vehicle arrangements for companies requiring transportation for staff and professional teams. Rental services can support daily commuting, temporary assignments, meetings, airport transfers, and corporate travel."
}
],
tableData: [
["Corporate Employee Cab Service Pune"],
["Corporate Employee Taxi Pune"],
["Employee Transportation Service Pune"],
["Corporate Cab for Employees Pune"],
["Office Employee Cab Pune"],
["Employee Pickup Drop Service Pune"],
["Corporate Cab Booking Pune"],
["Corporate Cab Rental Pune"],
["Daily Employee Cab Pune"],
["Monthly Employee Transportation Pune"],
["IT Employee Cab Service Pune"],
["Corporate Office Cab Pune"],
["Company Employee Transport Pune"],
["Corporate Airport Cab Pune"],
["Corporate Outstation Cab Pune"],
["AC Corporate Employee Cab Pune"],
["Affordable Employee Cab Service Pune"],
["Corporate Cab with Driver Pune"],
["Employee Cab Service Near Me Pune"],
["Staff Transportation Service Pune"],
["Corporate Taxi for Employees Pune"],
["Employee Office Pickup Drop Pune"],
["Corporate Travel Cab Pune"],
["Private Employee Transportation Pune"],
["Corporate Car Rental for Employees Pune"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Employee Transportation",
WhyChoosedescription: "Companies can arrange structured cab transportation for employees travelling between residential areas and workplaces across Pune. Pickup points, routes, and schedules can be coordinated according to office timings and employee requirements."
},
{
WhyChooseheading: "Support for IT and Corporate Corridors",
WhyChoosedescription: "Pune has several major business and technology corridors, including Hinjewadi, Kharadi, Magarpatta, Viman Nagar, and Baner. Corporate cabs can connect employees with these workplaces through planned daily commuting routes."
},
{
WhyChooseheading: "Daily and Monthly Scheduling",
WhyChoosedescription: "Employee transportation can be arranged for recurring daily requirements as well as monthly service plans. Companies can structure routes according to staff locations, working hours, shift timings, and the frequency of required transportation."
},
{
WhyChooseheading: "Airport Transportation for Professionals",
WhyChoosedescription: "Corporate employees, executives, clients, and visiting professionals may require transportation to and from Pune International Airport. Scheduled airport cabs can be coordinated around flight timings and workplace travel plans."
},
{
WhyChooseheading: "Corporate and Outstation Mobility",
WhyChoosedescription: "Employee transportation can extend beyond routine office commuting to include business meetings, client visits, training programs, conferences, factory inspections, and outstation assignments. Suitable cabs can be arranged according to the journey."
},
{
WhyChooseheading: "Driver-Based Travel",
WhyChoosedescription: "Driver-based corporate cabs provide convenient transportation for employees and professional teams without requiring them to manage the vehicle. This arrangement can be useful for office travel, meetings, airport transfers, and business trips."
},
{
WhyChooseheading: "Flexible Vehicle Requirements",
WhyChoosedescription: "Employee transportation needs can vary from individual staff travel to larger corporate teams. Vehicle arrangements can be selected according to passenger capacity, route distance, travel frequency, and the nature of the corporate journey."
},
{
WhyChooseheading: "Business Connectivity Across Pune",
WhyChoosedescription: "Corporate employee cab routes can connect major business, residential, industrial, airport, and commercial areas throughout Pune. This allows companies to organize transportation for employees working across different parts of the city and surrounding business corridors."
}
]
};








const faqData = [
{
question: "How can corporate employees arrange cab transportation in Pune with Citysky Cabs?",
answer: "Corporate employees can enquire about daily or occasional cab transportation by sharing their pickup location, office address, reporting time, passenger count, and travel schedule. Citysky Cabs can review the commuting requirement and discuss a suitable arrangement for regular office travel, meetings, airport transfers, or other business-related journeys."
},
{
question: "Can Citysky Cabs provide regular employee pickup and drop services in Pune?",
answer: "Companies can discuss recurring employee transportation for morning and evening office shifts, including scheduled pickup and drop routes across different parts of Pune. Employee addresses, office locations, shift timings, passenger numbers, and required service frequency can be shared to plan the corporate cab requirement."
},
{
question: "Can corporate employees from different areas of Pune travel to the same office by cab?",
answer: "Employees living in areas such as Hinjewadi, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Baner, and surrounding locations can enquire about shared corporate transportation. Pickup points and reporting times can be provided so Citysky Cabs can understand the route and group travel requirement."
},
{
question: "Is corporate cab service suitable for employees working in different shifts?",
answer: "Organizations operating morning, evening, night, or rotating shifts can discuss employee transportation according to their working hours. Sharing shift schedules, pickup locations, office addresses, and employee counts helps Citysky Cabs understand the transportation requirements for different groups."
},
{
question: "Can corporate employees use Citysky Cabs for Pune Airport transfers?",
answer: "Business professionals travelling through Pune Airport can enquire about airport transportation from their residence, office, hotel, or other locations in Pune. Flight timing, pickup address, passenger count, luggage requirements, and preferred reporting time can be shared when arranging the airport journey."
},
{
question: "Can companies arrange cabs for employees attending meetings and business events?",
answer: "Employees travelling to client meetings, conferences, training sessions, exhibitions, seminars, or business events can use dedicated cab transportation. Citysky Cabs can consider the employee's pickup location, event venue, reporting time, number of passengers, and return schedule while discussing the requirement."
},
{
question: "Can corporate employees hire cabs for outstation business travel from Pune?",
answer: "Professionals travelling from Pune to Mumbai, Nashik, Satara, Kolhapur, Aurangabad, Hyderabad, Bangalore, or other business destinations can enquire about outstation cab arrangements. The destination, travel date, passenger count, one-way or return requirement, and expected schedule can be shared for planning."
},
{
question: "Can Citysky Cabs provide transportation for senior executives and visiting employees?",
answer: "Companies can enquire about dedicated transportation for senior employees, visiting executives, consultants, clients, and other business guests. Depending on the itinerary, the cab requirement may include airport pickup, hotel transfers, office visits, meetings, and return transportation within Pune or to nearby destinations."
},
{
question: "Can corporate employees book a cab for late-night office travel in Pune?",
answer: "Employees working late shifts or finishing business activities outside regular office hours can enquire about cab transportation according to their required travel schedule. The pickup location, office address, shift ending time, passenger count, and destination can be shared with Citysky Cabs while discussing the transportation arrangement."
},
{
question: "What details are required for corporate employee cab services in Pune?",
answer: "Companies or employees can provide pickup locations, office addresses, reporting and departure timings, passenger count, travel frequency, preferred vehicle category, and required service dates. Details about multiple pickup points, shift-based transportation, airport transfers, or outstation business travel can also be included."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohan Kulkarni",
feedback:
"Our office team had employees travelling from different parts of Pune, and coordinating daily transportation was becoming difficult with changing reporting times. We shared the pickup areas and office schedule with Citysky Cabs, and the corporate cab arrangement made the regular employee commute much easier to coordinate.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Joshi",
feedback:
"I needed a cab for an early morning business meeting followed by an airport transfer later in the day. Citysky Cabs arranged the transportation around the schedule we provided, and having a dedicated vehicle made it convenient to manage the different parts of my workday without arranging separate local transport.",
rating: 5
}
];




































































































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service for Corporate Employees Pune",
  "image": "https://www.cityskycab.in/assets/images/best-cab-service-for-corporate-employees-pune.webp",
  "description": "Best Cab Service for Corporate Employees Pune from Citysky Cabs is designed for companies that need organized and convenient transportation for their employees, office staff and business teams. The service includes Corporate Employee Cab Service Pune, Corporate Employee Taxi Pune, Employee Transportation Service Pune and Corporate Cab for Employees Pune for regular workplace commuting. Office Employee Cab Pune and Employee Pickup Drop Service Pune can be planned according to employee residential locations, office timings and shift schedules. Corporate Cab Booking Pune and Corporate Cab Rental Pune provide flexible arrangements for recurring transportation, while Daily Employee Cab Pune and Monthly Employee Transportation Pune are suitable for organizations with regular staff travel requirements. IT Employee Cab Service Pune, Corporate Office Cab Pune and Company Employee Transport Pune support transportation for technology companies, corporate offices and business facilities. Corporate Airport Cab Pune and Corporate Outstation Cab Pune can be arranged for executives, employees, clients and business guests travelling outside the city. AC Corporate Employee Cab Pune and Affordable Employee Cab Pune provide practical options for comfortable and cost-conscious employee transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/best-cab-service-for-corporate-employees-pune"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Best Cab Service for Corporate Employees Pune | Employee Transport & Office Cab | +91 8554819191
  </title>

  <meta
    name="description"
    content="Best Cab Service for Corporate Employees Pune by Citysky Cabs for daily employee transport, office pickup and drop, IT staff travel, corporate cab rental, airport transfers and outstation business travel."
  />

  <meta
    name="keywords"
    content="Best Cab Service for Corporate Employees Pune, Corporate Employee Cab Service Pune, Corporate Employee Taxi Pune, Employee Transportation Service Pune, Corporate Cab for Employees Pune, Office Employee Cab Pune, Employee Pickup Drop Service Pune, Corporate Cab Booking Pune, Corporate Cab Rental Pune, Daily Employee Cab Pune, Monthly Employee Transportation Pune, IT Employee Cab Service Pune, Corporate Office Cab Pune, Company Employee Transport Pune, Corporate Airport Cab Pune, Corporate Outstation Cab Pune, AC Corporate Employee Cab Pune, Affordable Employee Cab Pune, Corporate Employee Transportation Pune, Pune employee cab service, Pune corporate employee taxi, Pune staff transportation service, Pune office employee cab, Pune employee pickup drop, Pune corporate cab service, Pune company employee transport, Pune daily employee cab, Pune monthly employee cab service, Pune IT employee transportation, Pune IT company cab, Pune corporate office taxi, Pune employee cab rental, Pune corporate cab rental, Pune airport employee cab, Pune outstation corporate cab, Pune AC employee taxi, Pune affordable corporate cab, Pune shift employee transportation, Pune employee night shift cab, Pune office pickup drop taxi, Pune corporate staff cab service, Pune business employee transport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/140.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabserviceforcorporate;